import { Pathnames } from 'next-intl/routing'

export const locales = ['en', 'es', 'zh', 'ru'] as const

export const localeNames: Record<(typeof locales)[number], string> = {
  en: 'English',
  es: 'Español',
  zh: '简体中文',
  ru: 'Русский',
}

export const defaultLocale = 'en'

export const localePrefix = 'as-needed'

export const localeDetection =
  process.env.NEXT_PUBLIC_LOCALE_DETECTION === 'true'

export const pathnames = {
  '/': '/',
  '/privacy-policy': '/privacy-policy',
  '/terms-of-service': '/terms-of-service',
} satisfies Pathnames<typeof locales>
